/**
 * 開発用シード接頭辞。DB 値はそのまま検索・API に使い、UI 表示だけ剥がす。
 * （本番で同名接頭辞を付ける運用は想定しない）
 */
export const SAMPLE_SEED_NAME_PREFIX = 'CASE_MGR_DUMMY_';

type TranslateFn = (key: string, options?: Record<string, unknown>) => string;

/**
 * 接頭辞除去後のシード固有名 → i18n キー。
 * Yeast / Influenza-A 等の実データ風の名はそのまま出す。
 */
export const SAMPLE_SEED_LABEL_KEYS: Readonly<Record<string, string>> = {
  Disposed: 'sample.seed_label.disposed',
  NoRoom: 'sample.seed_label.no_room',
  NoDrawer: 'sample.seed_label.no_drawer',
  NoCase: 'sample.seed_label.no_case',
  Drawer0: 'sample.seed_label.drawer0',
};

/** 一覧・ツリー・保管ラベル用の表示名（シード接頭辞＋既知シード名の人間向けラベル） */
export function formatEntityDisplayName(name: string, t?: TranslateFn): string {
  if (!name) return name;
  const base = name.startsWith(SAMPLE_SEED_NAME_PREFIX)
    ? name.slice(SAMPLE_SEED_NAME_PREFIX.length)
    : name;
  const labelKey = SAMPLE_SEED_LABEL_KEYS[base];
  if (labelKey && t) {
    return String(t(labelKey, { defaultValue: base }));
  }
  return base;
}

/**
 * 編集フォームで表示名のまま保存しても、未変更なら DB の生名を維持する。
 * （シード接頭辞や既知ラベルをユーザーが触っていないときの往復）
 */
export function resolveSampleNameForSubmit(
  editedName: string,
  originalName: string | null | undefined,
  t?: TranslateFn
): string {
  const edited = editedName.trim();
  if (!originalName) return edited;
  if (edited === originalName) return originalName;
  const display = formatEntityDisplayName(originalName, t);
  const stripped = formatEntityDisplayName(originalName);
  if (edited === display || edited === stripped) return originalName;
  return edited;
}

/**
 * 長い識別子を折り返しやすくする。
 * 表示名化したうえで `_` / `-` / `.` / `/` の直後にゼロ幅スペースを挿入。
 */
export function softBreakIdentifier(name: string, t?: TranslateFn): string {
  if (!name) return name;
  return formatEntityDisplayName(name, t).replace(/([_/.\-])/g, '$1\u200b');
}
